import { useEffect, useState } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useGetProfile } from '../pages/securitySettings/api/apiSecuritysettings';
import { useModalContext } from '../contexts/ModalContext';
import userAvatar from '../assets/images/userAvatar.png'
import menufold from '../assets/images/icons/menu-fold-outlined.svg'
import edit from '../assets/images/icons/edit-2.svg'
import lock from '../assets/images/icons/lock.svg'
import logoutIcon from '../assets/images/icons/logout.svg'
import logo from '../assets/images/logo.png'
import more from '../assets/images/icons/more.svg'
import moonImg from '../assets/images/icons/moon.svg'
import sunImg from '../assets/images/icons/sun.svg'
import { useSignOut } from '../Authentication/api/apiAuthentication';
import { CircularProgress, } from '@mui/material';
import UserExportButton from '../pages/withdraw-management/tabs/Check';


const DashboardHeader = () => {



    const [menuone, setMenuone] = useState(false);
    const [menutwo, setMenutwo] = useState(false);
    const [menuthree, setMenuthree] = useState(false);
    const { setProfiledata, setCommonloader, setTheme } = useModalContext();
    const logoutMutation = useSignOut()

    const [isHtmlClassActive, setIsHtmlClassActive] = useState(
        sessionStorage.getItem('theme-dark') === 'true'
    );

    const DarkThemeToggle = () => {
        setIsHtmlClassActive(!isHtmlClassActive);
        setTheme(!isHtmlClassActive)
        sessionStorage.setItem('theme-dark', !isHtmlClassActive);
    };

    isHtmlClassActive ? document.documentElement.classList.add('theme-dark') : document.documentElement.classList.remove('theme-dark')



    const navigate = useNavigate()
    const { data: getProfile, isLoading } = useGetProfile();


    useEffect(() => {
        if (getProfile) {
            setProfiledata(getProfile?.data)
            setCommonloader(isLoading)
        }
    }, [getProfile, isLoading, setProfiledata, setCommonloader])


    const logout = async () => {
        const response = await logoutMutation.mutateAsync({})
        if (response) {
            sessionStorage.removeItem("apayroucarayxczijiuhxvkdsp");
            sessionStorage.removeItem('theme-dark')
            sessionStorage.removeItem('permissions')
            sessionStorage.removeItem('role')
            navigate('/')
        }
    }


    let progressColor = isHtmlClassActive ? "#fff" : "black";
    const profileContent = isLoading ? <CircularProgress style={{ color: progressColor }} size={20} /> : <img src={getProfile?.data?.profilePicture || userAvatar} alt="profile" />;;












    return (

        <header className={`ad_pg_hd ${menuone ? "sdMuShow" : ""} ${menuthree ? "sdMuShrk" : ""}`.trim()}>
            <div className="container-fluid p-0">
                <div className="row ad_hd_row g-0">
                    <div className="col-auto d-none d-lg-block">
                        <Link to={''} className="ad_hd_logo ad_pg_lt_spc-lg" style={{ textDecoration: 'none' }}>
                            <img src={logo} className='img-fluid' alt="Logo" />
                        </Link>

                    </div>
                    <div className="col">
                        <div className="row align-items-center justify-content-between g-0 ad_hd_inr_row">
                            <div className="col-auto">
                                <div className="ad_hd_mu_tl">
                                    <button className="btn p-0 border-0 btnSdMu d-none d-lg-inline-block" onClick={() => setMenuthree(!menuthree)}>
                                        <img src={menufold} alt="menu-fold-outlined" />
                                    </button>
                                    <button className="btn p-0 border-0 btnSdMuMb d-lg-none" onClick={() => setMenuone(!menuone)}>
                                        <img src={menufold} alt="menu-fold-outlined" />
                                    </button>
                                </div>
                            </div>
                            <div className="col-auto d-lg-none">
                                <div className="ad_hd_logo">
                                    <img src={logo} alt="logo" className='img-fluid' />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="hdrRtCn">
                                    <button className="btn p-0 border-0 d-lg-none btnHdOpt" onClick={() => setMenutwo(!menutwo)}>
                                        <img src={more} alt="more" />
                                    </button>
                                    <div className={`ad_hd_lnstp ${menutwo ? "shwOpt" : ""}`.trim()}>
                                        <UserExportButton />
                                        <div className="ad_hd_ac_btn">
                                            <button className="btn border-0 theme-toggle" onClick={DarkThemeToggle}>
                                                <img src={moonImg} alt="moon" className="shw_light" />
                                                <img src={sunImg} alt="moon" className="shw_dark" />
                                            </button>
                                        </div>

                                        <div className="dropdown hdPrfDd">
                                            <UncontrolledDropdown>

                                                <DropdownToggle caret>
                                                    {profileContent}
                                                    <span>{getProfile?.name}</span>
                                                </DropdownToggle>

                                                <DropdownMenu>
                                                    <Link className='dropdown-item' to='/site-settings'>
                                                        <img src={edit} alt="edit-2" />
                                                        <span>Site Settings</span>
                                                    </Link>
                                                    <Link className='dropdown-item' to='/settings'>
                                                        <img src={lock} alt="lcok" />
                                                        <span>Security Settings</span>
                                                    </Link>

                                                    <button
                                                        className='dropdown-item'
                                                        onClick={logout}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter") { logout() }
                                                        }} >
                                                        <img src={logoutIcon} alt="logout" />
                                                        <span>Logout</span>
                                                    </button>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default DashboardHeader;















